import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { SvgIconProps } from '@mui/material/SvgIcon';
import { createLink, LinkProps, useMatchRoute } from '@tanstack/react-router';

const ListItemButtonLink = createLink(ListItemButton);

interface Props {
  disabled?: boolean;
  title: string;
  path: LinkProps['to'];
  Icon?: React.ComponentType<SvgIconProps>;
  isChildRoute?: boolean;
}

const SidebarNavListItem = ({
  disabled = false,
  title,
  path,
  Icon,
  isChildRoute = false,
}: Props) => {
  const matchRoute = useMatchRoute();
  const isSelected = !!matchRoute({ to: path, fuzzy: true }) && !disabled;

  const listItemSxProps = {
    paddingX: 1.5,
    paddingLeft: isChildRoute ? 6 : 1.5,
    borderRadius: 1,
  };

  return (
    <ListItem disableGutters disablePadding sx={{ overflow: 'hidden' }}>
      {isSelected ? (
        <ListItemButton
          sx={listItemSxProps}
          selected
          disableRipple
          disableTouchRipple
        >
          {Icon ? (
            <ListItemIcon sx={{ minWidth: 36 }}>
              <Icon color='primary' />
            </ListItemIcon>
          ) : null}
          <ListItemText
            primary={title}
            slotProps={{
              primary: { color: 'primary' },
            }}
          />
        </ListItemButton>
      ) : (
        <ListItemButtonLink
          sx={listItemSxProps}
          to={path}
          selected={isSelected}
          disabled={disabled}
        >
          {Icon ? (
            <ListItemIcon sx={{ minWidth: 36 }}>
              <Icon color='inherit' />
            </ListItemIcon>
          ) : null}
          <ListItemText
            primary={title}
            slotProps={{
              primary: { color: 'textPrimary' },
            }}
          />
        </ListItemButtonLink>
      )}
    </ListItem>
  );
};

export default SidebarNavListItem;
